export const ross1000 = {
  title: "ROSS 1000 / Turismo5",
  subtitle: "Statystyki ruchu turystycznego · sprawozdawczość regionalna",

  fields: {
    region: "Region",
    codice: "Kod obiektu",
    codiceHint: "Kod obiektu nadany przez region (pole «codice»).",
    username: "Nazwa użytkownika",
    password: "Hasło",
    passwordHint: "Dane logowania do usługi sieciowej ROSS 1000 (wydawane przez region / GIES).",
    prodotto: "Nazwa oprogramowania",
    camereDisponibili: "Dostępne pokoje",
    lettiDisponibili: "Dostępne łóżka",
    defaultTipoturismo: "Rodzaj turystyki (domyślny)",
    defaultMezzotrasporto: "Środek transportu (domyślny)",
    useTestEndpoint: "Używaj środowiska testowego",
    endpointResolved: "Punkt końcowy",
    keepBlank: "(pozostaw puste, aby zachować obecne)",
  },

  regionOptions: {
    sardegna: "Sardynia",
    lazio: "Lacjum",
    veneto: "Wenecja Euganejska",
    emilia_romagna: "Emilia-Romania",
    toscana: "Toskania",
    piemonte: "Piemont",
    lombardia: "Lombardia",
    liguria: "Liguria",
    marche: "Marche",
    abruzzo: "Abruzja",
    molise: "Molise",
    calabria: "Kalabria",
    basilicata: "Basilicata",
  },

  actions: {
    saveAndVerify: "Zapisz i zweryfikuj",
    updateCredentials: "Zaktualizuj dane logowania",
    verifyConnection: "Zweryfikuj połączenie",
    saving: "Zapisywanie...",
    verifying: "Weryfikowanie...",
  },

  status: {
    connectionOk: "Dane logowania zapisane, a połączenie pomyślnie zweryfikowane.",
    connectionError: "Błąd połączenia. Sprawdź wprowadzone dane logowania.",
    connectionPending: "Połączenie nie zostało jeszcze zweryfikowane. Kliknij «Zweryfikuj połączenie», aby to potwierdzić.",
  },

  validation: {
    codiceRequired: "Kod obiektu jest wymagany.",
    usernameRequired: "Nazwa użytkownika jest wymagana.",
    passwordRequired: "Hasło jest wymagane.",
    capacityRequired: "Podaj liczbę dostępnych pokoi i łóżek.",
  },

  toasts: {
    saveSuccess: "Dane logowania zapisane, a połączenie pomyślnie zweryfikowane.",
    saveWarning: "Dane logowania zapisane, ale nie udało się zweryfikować połączenia.",
    saveError: "Nie udało się zapisać danych logowania.",
    testSuccess: "Połączenie z ROSS 1000 pomyślnie zweryfikowane.",
    testError: "Nie udało się zweryfikować połączenia.",
    statusActive: "ROSS 1000 włączone.",
    statusInactive: "ROSS 1000 wyłączone.",
  },
};
